// <fp-look-picker> (sections/fp-character-profile.liquid): a character with several looks (product metafield
// fantastical.looks) shows one radio pill per look. Picking one swaps the big portrait ([data-fp-look-img]),
// adds ?look={key} to every "Create Your Video" link on the page ([data-fp-create-link]) and mirrors the choice in
// the address bar so a reload or shared link keeps it. ?look= in the URL preselects a look on load.

class FpLookPicker extends HTMLElement {
  connectedCallback() {
    this.inputs = [...this.querySelectorAll('input[type="radio"]')];
    if (!this.inputs.length) return;

    const wanted = new URLSearchParams(location.search).get('look');
    const preset = this.inputs.find((i) => i.value === wanted);
    if (preset) preset.checked = true;

    this.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) this.apply(event.target, true);
    });
    this.apply(this.inputs.find((i) => i.checked) || this.inputs[0], false);
  }

  apply(input, fromUser) {
    const key = input.value;
    const scope = this.closest('.fp-profile') || document;

    for (const img of scope.querySelectorAll('[data-fp-look-img]')) {
      const show = img.dataset.fpLookImg === key;
      img.hidden = !show;
      if (show && img.dataset.src) {
        // Non-default looks load lazily; promote the picked one.
        img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        delete img.dataset.src;
        delete img.dataset.srcset;
      }
    }

    for (const link of document.querySelectorAll('[data-fp-create-link]')) {
      const url = new URL(link.getAttribute('href'), location.origin);
      url.searchParams.set('look', key);
      link.setAttribute('href', url.pathname + url.search);
    }

    // Play sample: open the look's own sample when it has one, else the character's default sample.
    const play = scope.querySelector('.fp-profile__play');
    const base = this.dataset.modalBase;
    if (play && base) {
      const own = document.getElementById(`${base}-${key}`);
      const target = own ? own.id : base;
      play.dataset.fpModalOpen = target;
      play.setAttribute('aria-controls', target);
    }

    const name = document.querySelector('[data-fp-sticky-look]');
    if (name) name.textContent = input.dataset.label || '';

    if (fromUser) {
      const url = new URL(location.href);
      url.searchParams.set('look', key);
      history.replaceState(history.state, '', url);
    }
  }
}

if (!customElements.get('fp-look-picker')) customElements.define('fp-look-picker', FpLookPicker);
